module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"exams":"Prüfungen","learning":"Unterweisung","subjects":"Module","trainees":"Trainees"},"en":{"exams":"Exams","learning":"Learning","subjects":"Subjects","trainees":"Trainees"}}')
  delete Component.options._Ctor
}
